export default "__VITE_ASSET__BlTc0_dV__"